var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('form',[_c('p',{staticClass:"presence-modal-content"},[_vm._v("Czy chcesz wpisać się na elektroniczną listę obecności?")])])
}]

export { render, staticRenderFns }